<template>
  <a-modal v-model="visible" :title="title" :destroyOnClose="true" :width="800">
    <a-form-model ref="manageInstanceForm" :model="subscription" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-model-item label="Subscription Plan" prop="subscriptionPlanId">
            <a-select v-model="subscription.subscriptionPlanId" style="width: 100%">
              <a-select-option v-for="plan in plans" :key="plan.id" :value="plan.id">
                {{ plan.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="Start Date" prop="startDate">
            <DateTimePickr
              :date="subscription.startDate"
              :value="subscription.startDate"
              @input="
                (newDate) => {
                  subscription.startDate = newDate;
                }
              "
              @onChange="onStartDateChange"
            ></DateTimePickr>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="Subscription Quantity" prop="subscriptionQuantity">
            <a-input-number class="width-100" v-model="subscription.subscriptionQuantity" :min="1" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="save" :loading="isSaving">Save</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>

<script>
import modalMixin from '../Common/Mixins/modalMixin';
import { helper } from '../../Utilities/helper';

const EVENTS = { add: 'add' };

export default {
  mixins: [modalMixin],
  props: {
    subscription: { type: Object, default: () => {} },
    plans: Array,
    isSaving: Boolean,
  },
  data() {
    return {
      rules: {
        subscriptionPlanId: [{ required: true, message: 'Please select a subscription plan', trigger: 'change' }],
        startDate: [
          { required: true, message: 'Please select a start date', trigger: 'blur' },
          { validator: helper.dateFormatValidator, trigger: 'blur' },
        ],
        subscriptionQuantity: [{ required: true, message: 'Please select a subsctiption quantity', trigger: 'blur' }],
      },
    };
  },
  methods: {
    save() {
      this.$refs.manageInstanceForm.validate(async (valid) => {
        if (valid) {
          this.$emit(EVENTS.add, this.subscription);
        }
      });
    },
    onStartDateChange(val) {
      this.subscription.startDate = val;
    }
  },
  computed: {
    startDate() {return this.subscription.startDate;}
  },
  watch: {
    startDate() {
      this.$refs.editInstanceForm?.validateField('startDate');
    },
  },
};
</script>

<style lang="scss" scoped></style>
